// extracted by mini-css-extract-plugin
module.exports = {"filterSelectorItem":"FilterSelectorItem_filterSelectorItem__3auQH","circleColor":"FilterSelectorItem_circleColor__2sb4p","label":"FilterSelectorItem_label__ur8NE"};